<template>
  <div id="centerRight2">
    <div class="chartInstanceBox">
      <div class="chartInstanceBoxTitle">
        项目类型占比
      </div>
      <div id="chartInstance" ref="chartInstance"> </div>
    </div>
  </div>
</template>

<script>
import { getProjectTypeRationApi } from '@/utils/api'

export default {
  data() {
    return {
      projectTypeRation: ''
    }
  },
  mounted() {
    this.getProjectTypeRation()
  },

  methods: {

    async getProjectTypeRation(data) {
      await getProjectTypeRationApi({
        ...data
      }).then(res => {
        this.projectTypeRation = res.data.data
        this.chartInstanceInit()
      })
    },

    chartInstanceInit() {
      // console.log(this.projectTypeRation, 'projectTypeRation');
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
        tooltip: {
          trigger: 'axis'
        },
        radar: {
          indicator: this.projectTypeRation.indicator.length?this.projectTypeRation.indicator:[],
          center: ['50%', '49%'],
          radius: '70%',
          startAngle: 90,
          splitNumber: 7,
          shape: 'circle',
          axisName: {
            formatter: '{value}',
            color: '#fff'
          },
          tooltip: {
            trigger: 'item'
          },
          splitArea: {
            areaStyle: {
              color: 'rgba(255,0,0,0)', // 图表背景的颜色
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(40,239,239,0.2)'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#284046'
            }
          }
        },
        series: [
          {
            name:'项目类型占比',
            type: 'radar',
            emphasis: {
              lineStyle: {
                width: 4
              }
            },
            tooltip: {
              trigger: 'item'
            },
            data: [
              {
                value: this.projectTypeRation.data,
                areaStyle: {
                  color: 'rgba(40,239,239,0.2)'
                },
                label: {
                  show: true,
                  color: '#fff',
                  formatter: function (params) {
                    // console.log(params, '++++++');
                    return params.value;
                  },
                  labelStyle: {
                    color: '#fff'
                  }
                }
              }
            ]
          }
        ]
      };
      if (this.projectTypeRation.data.length==0) {
        initOption.series = []
      }
      chartInstance.setOption(initOption,true)
    },

    //切换行业类型
    clickAction(e) {
      this.industryType = e
    },
  }
}
</script>

<style lang="scss" scoped>
#chartInstance {
  width: 480px;
  height: 220px;
}

.chartInstanceBox {
  position: relative;
  width: 480px;
  padding-right: 68px;

  .chartInstanceBoxTitle {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 28px;
    color: #0EE1F4;
    background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: right;
  }
}
</style>
